import http from '../../../lib/http'

export const GET_DOCUMENT = 'GET_DOCUMENT'
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS'
export const GET_DOCUMENT_FAILURE = 'GET_DOCUMENT_FAILURE'
export const CLEAR_DOCUMENT = 'CLEAR_DOCUMENT'

export function getDocument (
  patientId,
  documentId,
  chatId,
  participantId,
  documentType,
  clientName
) {
  return dispatch => {
    dispatch({ type: GET_DOCUMENT })
    const url =
      documentType === 'MessageAttachment'
        ? `/patients/${patientId}/messages/${chatId}/attachment/${documentId}?participant=${participantId}&downloadType=encoded`
        : `/patients/${patientId}/documents/${documentId}?documentType=${documentType}&downloadType=encoded`

    return http
      .getRequest(url, {}, { clientName })
      .then(response => {
        dispatch({
          type: GET_DOCUMENT_SUCCESS,
          file: response
        })
      })
      .catch(err => dispatch({
        type: GET_DOCUMENT_FAILURE,
        error: err
      }))
  }
}
